import { NgModule }        					            from '@angular/core';
import { HttpClientModule,HTTP_INTERCEPTORS} 	        from '@angular/common/http';
import { BrowserModule }   					            from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule}              from '@angular/forms';
import { MatNativeDateModule, MatTabsModule } 				            from '@angular/material';
import { platformBrowserDynamic } 			            from '@angular/platform-browser-dynamic';
import { BrowserAnimationsModule }                      from '@angular/platform-browser/animations';

import { FullCalendarModule }                           from 'ng-fullcalendar';
import { SweetAlert2Module }                            from '@toverux/ngx-sweetalert2';
import { WebcamModule }                                 from 'ngx-webcam';
import { ChartsModule }                                 from 'ng2-charts';
import { NgxSpinnerModule }                             from 'ngx-spinner';
import { NgbModule } 							        from '@ng-bootstrap/ng-bootstrap';
import { LightboxModule }                               from 'ngx-lightbox';
import { AppRoutingModule }                             from './app-routing.module';
import { DemoMaterialModule }                           from './material-module';
import { AppComponent }                                 from './app.component';
import { HeaderComponent }                              from './layouts/header.component';
import { LoginComponent }                               from './login/login.component';
import { AuthComponent }                                from './login/auth.component';
import { DashboardComponent }                           from './dashboard/dashboard.component';
import { ProctorComponent }                             from './proctor/proctor.component';
import { ReportComponent }                              from './report/report.component';
import { StudentlistComponent }                         from './report/studentlist.component';
import { ExamlistComponent }                            from './examlist/examlist.component';
import { VivalistComponent }                            from './viva/vivalist.component';
import { ClientviewComponent }                          from './clientview/clientview.component';

import { PublisherComponent }                           from './publisher/publisher.component';
import { SubscriberComponent }                          from './subscriber/subscriber.component';

import {VgCoreModule}                                   from 'videogular2/core';
import {VgControlsModule}                               from 'videogular2/controls';
import {VgOverlayPlayModule}                            from 'videogular2/overlay-play';
import {VgBufferingModule}                              from 'videogular2/buffering';

import { AlertComponent }                               from './_directives';
import { AuthGuard }                                    from './_guards';
import { JwtInterceptor, ErrorInterceptor, Globals}     from './_helpers';
import { SearchFilterPipe }                             from './_pipes';

import { AlertService, AuthenticationService, DashboardService, ProctorService, VivaService, OpentokService}  from './_services';
import { ExamLinkComponent } from './exam-link/exam-link.component';
import { NgxCarouselModule } from 'ngx-carousel';
import { VideosComponent } from './videos/videos.component';
import { PracticalComponent } from './practical/practical.component';
import { LivefeedComponent } from './proctor/livefeed.component';

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        FormsModule,
        HttpClientModule,
        DemoMaterialModule,
        ReactiveFormsModule,
        MatNativeDateModule,
        NgbModule,
        FullCalendarModule,
        WebcamModule,
        ChartsModule,
        MatTabsModule,
        NgxSpinnerModule,
        LightboxModule,
        NgxCarouselModule,
        VgCoreModule,
        VgControlsModule,
        VgOverlayPlayModule,
        VgBufferingModule,
        SweetAlert2Module.forRoot(),
    ],
    declarations: [
        AppComponent,
        HeaderComponent,
        LoginComponent,
        AuthComponent,
        DashboardComponent,
        ProctorComponent,
        ReportComponent,
        StudentlistComponent,
        ExamlistComponent,
        VivalistComponent,
        SearchFilterPipe,
        PublisherComponent,
        SubscriberComponent,
        ClientviewComponent,
        ExamLinkComponent,
        VideosComponent,
        PracticalComponent,
        LivefeedComponent,
    ],
    entryComponents: [AppComponent],
    bootstrap: [AppComponent],
    providers: [
        Globals,
        AuthGuard,
        AlertService,
        AuthenticationService,
        DashboardService,
        ProctorService,
        VivaService,
        OpentokService,
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },

    ]
})
export class AppModule { }

platformBrowserDynamic().bootstrapModule(AppModule);
